module.exports = __webpack_public_path__ + "static/media/logo_small.a3ac3fe1.svg";